import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type RoleUpdateFailedAction = {
	type: 'ROLE_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): RoleUpdateFailedAction => ({
	type: 'ROLE_UPDATE_FAILED',
	payload,
});
